import SquareDown from './SquareDown'

export default SquareDown
